import styled from 'styled-components';
import { CMS as CommonContent } from 'assets/Common/CMS';

export const Wrapper = styled.div`
  display: block;
  max-width: 100%;
`;

export const Content = styled.pre`
  ${CommonContent}
  white-space: pre-line;
  background-color: ${props => props.theme.backgroundColor || 'transparent'};
`;
